import { useCallback } from "react";
import api from "../config/api/axiosConfig";

export const useLogApi = () => {
  const getLogsByFontenehusId = useCallback(
    async (fontenehusId?: number, dateFrom?: string, dateTo?: string) => {
      const params = new URLSearchParams();
      if (fontenehusId) params.append("fontenehusId", fontenehusId.toString());
      if (dateFrom) params.append("dateFrom", dateFrom);
      if (dateTo) params.append("dateTo", dateTo);

      const response = await api.get("/Log?" + params.toString());
      return response;
    },
    [],
  );

  return {
    getLogsByFontenehusId,
  };
};
